import styled from 'styled-components';
import { $background } from '../../index';

export const Styles = styled.div`
    background: ${$background};
    padding: 30px 25px;
    margin: 20px 0;
`;
